import { render, staticRenderFns } from "./mBtnLong.vue?vue&type=template&id=2fc36294&"
import script from "./mBtnLong.vue?vue&type=script&lang=js&"
export * from "./mBtnLong.vue?vue&type=script&lang=js&"
import style0 from "./mBtnLong.vue?vue&type=style&index=0&id=2fc36294&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports